import {
	BULLETIN_TAGS_FETCH_REQUEST,
	BULLETIN_TAGS_FETCH_FAILURE,
	BULLETIN_TAGS_FETCH_SUCCESS,
	BULLETIN_TAG_FETCH_REQUEST,
	BULLETIN_TAG_FETCH_FAILURE,
	BULLETIN_TAG_FETCH_SUCCESS,
	BULLETIN_TAG_UPDATE_REQUEST,
	BULLETIN_TAG_UPDATE_FAILURE,
	BULLETIN_TAG_UPDATE_SUCCESS,
	BULLETIN_TAG_CREATE_REQUEST,
	BULLETIN_TAG_CREATE_FAILURE,
	BULLETIN_TAG_CREATE_SUCCESS,
	BULLETIN_TAG_SET,
	BULLETIN_TAG_RESET_MESSAGE,
} from '../constants/actionTypes';

const initialState = {
	isFetching: false,
	isUpdating: false,
	isCreating: false,
	isDeleting: false,
	message: {
		type: '',
		text: '',
	},
	selected: false,
};

export default function reducer(state = initialState, action) {
	const { type, payload } = action;

	switch (type) {
		case BULLETIN_TAG_SET:
			return {
				...state,
				selected: Number(payload.id),
			};

		case BULLETIN_TAG_RESET_MESSAGE:
			return {
				...state,
				message: {
					type: '',
					text: '',
				},
			};

		case BULLETIN_TAGS_FETCH_REQUEST:
			return {
				...state,
				isFetching: true,
				message: {
					type: '',
					text: '',
				},
				selected: false,
			};

		case BULLETIN_TAGS_FETCH_FAILURE:
			return {
				...state,
				isFetching: false,
				message: {
					type: 'error',
					text: payload.message,
				},
				selected: false,
			};

		case BULLETIN_TAGS_FETCH_SUCCESS:
			return {
				...state,
				isFetching: false,
				message: {
					type: '',
					text: '',
				},
			};

		case BULLETIN_TAG_FETCH_REQUEST:
			return {
				...state,
				isFetching: true,
				message: {
					type: '',
					text: '',
				},
				selected: false,
			};

		case BULLETIN_TAG_FETCH_FAILURE:
			return {
				...state,
				isFetching: false,
				message: {
					type: 'error',
					text: payload.message,
				},
				selected: false,
			};

		case BULLETIN_TAG_FETCH_SUCCESS:
			return {
				...state,
				isFetching: false,
				message: {
					type: '',
					text: '',
				},
				selected: Number(payload.id),
			};

		case BULLETIN_TAG_UPDATE_REQUEST:
			return {
				...state,
				isUpdating: true,
				message: {
					type: '',
					text: '',
				},
			};

		case BULLETIN_TAG_UPDATE_FAILURE:
			return {
				...state,
				isUpdating: false,
				message: {
					type: 'error',
					text: payload.message,
				},
			};

		case BULLETIN_TAG_UPDATE_SUCCESS:
			return {
				...state,
				isUpdating: false,
				message: {
					type: 'success',
					text: payload.message,
				},
			};

		case BULLETIN_TAG_CREATE_REQUEST:
			return {
				...state,
				isCreating: true,
				message: {
					type: '',
					text: '',
				},
			};

		case BULLETIN_TAG_CREATE_FAILURE:
			return {
				...state,
				isCreating: false,
				message: {
					type: 'error',
					text: payload.message,
				},
			};

		case BULLETIN_TAG_CREATE_SUCCESS:
			return {
				...state,
				isCreating: false,
				message: {
					type: 'success',
					text: payload.message,
				},
			};

		default:
			return state;
	}
}



// WEBPACK FOOTER //
// ./src/reducers/bulletinTags.js